module.exports = __webpack_public_path__ + "assets/img/11_476_big.144c2865.jpg";